import React, { Fragment } from "react";
import { NoRecordsBanner } from '../OopsBanner';

export default function RenderBusinessHero({ data, layout = "1" }: { data: any, layout: string }) {
    if (data?.isStenciled) {

        return <div className="stenciled  flex-column gap-small h-full w-full">
            <div className='w-full h-full stencil-item' ></div>
        </div>
    }

    else if (!data || data.length == 0)
        return <NoRecordsBanner message='Business Hero Image is not available.' />

    switch (layout) {
        default:
            return (<Fragment>
                <div className={"w-full h-full " + (data.isStenciled ? "stenciled" : "")}>
                    <span className="w-full h-full stencil-item no-a fixed-image-dimension" style={{ display: "block", backgroundImage: `url(${data.image})`, backgroundPosition: "center", backgroundSize: "cover" }}></span>
                </div>
            </Fragment >
            )
    }
}
